import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import { getChannelActivity } from '../../api/activity';
import { generateChannelCIDKey } from '../../utils/generateChannelCIDKey';

import { REQUEST } from '../../constants/request';

export const loadChannelActivity = createAsyncThunk(
  'feed/activity/channel',
  async (args, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getChannelActivity(args, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

const INITIAL_STATE = {
  byChannelId: {},
  currentRequestIds: {},
  currentLoadings: {},
  currentErrors: {},
};

export const ActivitySlice = createSlice({
  name: 'activity',
  initialState: INITIAL_STATE,
  reducers: {
    resetActivitySlice: () => INITIAL_STATE,
  },
  extraReducers: {
    [loadChannelActivity.pending]: (state, { meta }) => {
      const { orgId, streamId, channelId } = meta.arg;
      const uid = generateChannelCIDKey({ orgId, streamId, channelId });

      state.currentRequestIds[uid] = meta.requestId;
      state.currentLoadings[uid] = REQUEST.pending;
    },
    [loadChannelActivity.fulfilled]: (state, { payload, meta }) => {
      const { orgId, streamId, channelId } = meta.arg;
      const uid = generateChannelCIDKey({ orgId, streamId, channelId });

      if (meta.arg.offset > 0) {
        state.byChannelId[uid] = [...state.byChannelId[uid], ...payload];
      } else state.byChannelId[uid] = payload;

      state.currentRequestIds[uid] = undefined;
      state.currentLoadings[uid] = REQUEST.idle;
      state.currentErrors[uid] = undefined;
    },
    [loadChannelActivity.rejected]: (state, { payload, meta }) => {
      const { orgId, streamId, channelId } = meta.arg;
      const uid = generateChannelCIDKey({ orgId, streamId, channelId });

      state.currentRequestIds[uid] = undefined;
      state.currentLoadings[uid] = REQUEST.idle;
      state.currentErrors[uid] = payload;
    },
  },
});

export const { resetActivitySlice } = ActivitySlice.actions;

export default ActivitySlice.reducer;

export const selectorChannelActivity = (state, uid) =>
  state.activity.byChannelId[uid] || [];

export const selectorActivityLoadingStatus = (state, uid) =>
  state.activity.currentLoadings[uid] || REQUEST.idle;
